import api from '../config/api';

const homeSectionDefinitionService = {
  async getAll() {
    const response = await api.get('/api/home-sections/definitions');
    return response.data;
  },

  async create(payload) {
    const response = await api.post('/api/home-sections/definitions', payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await api.put(`/api/home-sections/definitions/${id}`, payload);
    return response.data;
  },

  async reorder(items) {
    const response = await api.put('/api/home-sections/definitions/reorder', { items });
    return response.data;
  },

  async remove(id) {
    const response = await api.delete(`/api/home-sections/definitions/${id}`);
    return response.data;
  },
};

export default homeSectionDefinitionService;
